import SprintList from '../components/sprint/SprintList';
import { useApp } from '../context/AppContext';
import TaskModal from '../components/task/TaskModal';

export default function SprintsPage() {
  const { state, dispatch } = useApp();
  const selectedTask = state.tasks.find(t => t.id === state.selectedTaskId);

  return (
    <>
      <SprintList />
      {selectedTask && (
        <TaskModal
          task={selectedTask}
          onClose={() => dispatch({ type: 'SELECT_TASK', payload: null })}
        />
      )}
    </>
  );
}
